// removed by extract-text-webpack-plugin
module.exports = {"Order":"Order__Order__2xmxz","id":"Order__id__1Twt1","Products":"Order__Products__1cVJx","productInfo":"Order__productInfo__1ttHL","img":"Order__img__u4dQ9","address":"Order__address__2TKzV","date":"Order__date__3quo9","status":"Order__status__3KhRl","button":"Order__button__1c240","addressDetails":"Order__addressDetails__dM66Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/orders/order/Order.css
// module id = 6053
// module chunks = 0